import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useAuth from '../hooks/useAuth';
import { setReturnTo } from '../utils/returnTo';

export interface IProtectedRouteProps {
  isGuestRoute?: boolean;
  redirectPath?: string;
  authenticatedRedirect?: string;
  unauthenticatedRedirect?: string;
  children?: React.ReactElement;
}

const isEntireUrl = (url: string) => {
  return url.startsWith('http://') || url.startsWith('https://');
};

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({
  isGuestRoute = false,
  redirectPath,
  authenticatedRedirect = '/',
  unauthenticatedRedirect = '/login',
  children,
}) => {
  const { token } = useAuth();
  const location = useLocation();
  const isAuthenticated = !!token?.accessToken;

  // determine the redirect route
  const redirectRoute =
    redirectPath ||
    (isGuestRoute ? authenticatedRedirect : unauthenticatedRedirect);

  if (
    (isAuthenticated && !isGuestRoute) ||
    (!isAuthenticated && isGuestRoute)
  ) {
    return children ? children : <Outlet />;
  }

  if (!isGuestRoute) {
    setReturnTo(`${location.pathname}${location.search}`);
  }

  if (isEntireUrl(redirectRoute)) {
    window.location.href = redirectRoute;
    return null;
  }

  // deny access and redirect
  return <Navigate to={redirectRoute} replace />;
};

export default ProtectedRoute;
